// Internal Module Imports
import { BASE_URL_BIDDING_SERVICE } from '../../constants';
import { HttpClient } from '../../utils/httpClient';

const PATH = {
    get: `/${BASE_URL_BIDDING_SERVICE}/client/economics`,
    dashboardCard: `/${BASE_URL_BIDDING_SERVICE}/client/economics/dashboard-card`,
};

const GetEconomics = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.get}`, { params }).then(callback).catch(error).finally(next);
};

const DashboardRevenueCard = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.dashboardCard}`, { params }).then(callback).catch(error).finally(next);
};

export const EconomicsService = {
    GetEconomics,
    DashboardRevenueCard,
};
